// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__F6_VH","content":"styles_content__1xkhS","checkbox":"styles_checkbox__1VcTu","checkboxLabel":"styles_checkboxLabel__1MsLy"};